import { ExistingProject } from "../../models/project";
import { ExistingCraftRecord } from "../../models/craft-record";
import { ExistingCustomer } from "../../models/customer";
import { convertToReadableTimestampDate } from "../../assets/js/convertToReadableTimestamp";

interface ProjectHeaderProps {
  project: ExistingProject;
  craftRecords: ExistingCraftRecord[];
  customer: ExistingCustomer | null;
}

export default function ProjectHeader({
  project,
  customer,
}: ProjectHeaderProps) {
  return (
    <div className="flex-1">
      <h1 className="mb-2 text-2xl font-medium text-gray-900">
        {project.title}
      </h1>
      {project.description && (
        <p className="mb-4 text-gray-700">{project.description}</p>
      )}
      <div className="flex flex-wrap gap-2 text-sm">
        <div className="rounded-md bg-blue-50 px-2 py-1 text-blue-700">
          Created: {convertToReadableTimestampDate(project.timestampCreated)}
        </div>
        <div className="rounded-md bg-blue-50 px-2 py-1 text-blue-700">
          Status: {project.open ? "Open" : "Closed"}
        </div>
        {customer && (
          <div className="rounded-md bg-blue-50 px-2 py-1 text-blue-700">
            Customer: {customer.name}
          </div>
        )}
      </div>
    </div>
  );
}
